export class TypeSweet {
    static error = 'error';
    static success = 'success';
    static info = 'info';
    static question = 'question';
}